// @flow

import React, { type Element, useState } from 'react'
import { Box, Grid, Typography } from '@material-ui/core'
import type { Facility } from '../../types'
import StarIcon from '@material-ui/icons/Star'
import { grey, yellow } from '@material-ui/core/colors'
import { getCsrfToken, request } from '../../../Common/Request'

type Props = {|
  option: Facility,
  handleServerErrors: ({ [string]: Array<string> }) => void,
  updateFacilityFavorite: (number, boolean) => void,
|}

function FacilityOption({
  option,
  handleServerErrors,
  updateFacilityFavorite,
}: Props): Element<typeof React.Fragment> {
  const [isFavorite, setIsFavorite] = useState(option.favorite)

  const handleFavorite = async (event): Promise<boolean> => {
    event.stopPropagation()

    const action = isFavorite ? 'remove_favorite' : 'add_favorite'
    const path = `/user/${action}/bc_facility/${option.id}`
    const headers = { 'X-CSRF-Token': getCsrfToken() }

    return await request(path, 'PUT', headers, '', handleServerErrors, handleFavoriteSuccess)
  }

  const handleFavoriteSuccess = (_data) => {
    setIsFavorite(!isFavorite)
    updateFacilityFavorite(option.id, !isFavorite)
  }

  return (
    <Grid item xs={12}>
      <Grid container direction="row">
        <Grid item xs={8}>
          <Box component="p" mb={0} fontWeight="fontWeightBold">
            {option.code}: {option.name}
          </Box>
          {option.city && option.address && (
            <Typography>
              {option.address}, {option.city}
            </Typography>
          )}
        </Grid>
        {!option.private && (
          <Grid item xs={4}>
            <Grid container justify="flex-end">
              <StarIcon
                style={{ color: isFavorite ? yellow[700] : grey[400] }}
                onClick={handleFavorite}
              />
            </Grid>
          </Grid>
        )}
      </Grid>
    </Grid>
  )
}

export default FacilityOption
